module.exports = __webpack_public_path__ + "static/media/e11.eed4488a.jpg";